<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{ header }}</h5>
    </div>
    <b-form class="location-form" @submit.prevent="onSubmit()">
      <legend>Detail</legend>
      <div class="form-row">
        <div class="form-group col-md-12">
          <label>Company</label>
          <multiselect
            name="company"
            v-model="selectedCustomer"
            :options="customers"
            label="name"
            track-by="id"
            v-validate="'required'"
            placeholder="Select company"
            :disabled="isAddFromSelectedCustomer"
            :class="{'multiselect-danger': errors.has('company')}"/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Code</label>
          <input
            v-model.trim="form.code"
            type="text"
            placeholder="Enter location code"
            class="form-control"
            name="code"
            v-validate="'required'"
            :class="{'is-invalid': errors.has('code')}">
          <b-form-feedback>{{ errors.first('code') }}</b-form-feedback>
        </div>
        <div class="form-group col-md-6">
          <label>Name</label>
          <input
            v-model.trim="form.name"
            type="text"
            placeholder="Enter location name"
            class="form-control"
            name="name"
            v-validate="'required'"
            :class="{'is-invalid': errors.has('name')}">
          <b-form-feedback>{{ errors.first('name') }}</b-form-feedback>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-12">
          <label>Location</label>
            <b-row>
              <b-col cols="10" sm="10" md="11" class="input-address mt-2 ml-5">
                <input class="form-control" type="text" v-model="address.query" placeholder="Search Address"/>
                <b-collapse id="suggestion" class="mt-1" :visible="address.openSuggestion">
                  <b-card no-body class="mb-0">
                    <b-card-body class="p-2">
                      <p class="card-text" @click="selectLocation()" style="cursor: pointer;">{{ address.suggestion.formatted_address }}</p>
                    </b-card-body>
                  </b-card>
                </b-collapse>
              </b-col>
            </b-row>
          <div v-if="!isFormReset">
          <l-map
            ref="map"
            :zoom.sync="map.zoom"
            :center="map.center">
            <l-tile-layer :url="map.url">
            </l-tile-layer>
          </l-map>
          </div>
        </div>
      </div>
      <hr>
      <b-button
        type="submit"
        variant="primary">Save changes</b-button>
      <b-button
        @click="onCancel()"
        type="reset"
        variant="outline-secondary"
        class="pull-right">Cancel</b-button>
    </b-form>
  </b-card>
</template>
<script>
/* eslint no-underscore-dangle: 0 */
import {
  isEmpty, isUndefined, debounce, find,
  uniqBy, concat, map, values, findLast,
  isNull, get,
} from 'lodash';
import Multiselect from 'vue-multiselect';
import L from 'leaflet';
import { LMap, LTileLayer } from 'vue2-leaflet';
import 'leaflet-draw';

export default {
  components: {
    LMap,
    LTileLayer,
    Multiselect,
  },
  name: 'location_create_edit',
  data() {
    return {
      form: {
        id: null,
        type: 1,
        code: '',
        name: '',
        latitude: 0,
        longitude: 0,
        company_id: '',
        metadata: {},
        geometry: {
          type: '',
          coordinates: '',
        },
      },
      map: {
        zoom: 4,
        center: [-25.641526, 135.441023],
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      },
      mapObject: {},
      address: {
        query: '',
        suggestion: '',
        openSuggestion: false,
        finish: false,
      },
      selectedCustomer: '',
      isSubmit: false,
    };
  },
  created() {
    let { companyId } = this.$route.params;
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'locations', name: 'Locations' },
      { to: this.locationId, name: 'Detail' },
      { to: 'edit', name: 'Edit' },
    ];

    const queryCompanyId = get(this.$route, 'query.company_id', null);
    if (!isNull(queryCompanyId)) {
      companyId = queryCompanyId;
    }

    if (!this.isEdit) {
      breadcrumb.splice(3, 2);
      breadcrumb.push({ to: 'create', name: 'Create' });
    } else {
      this.$store.commit('shipment_md/locations/SET_DETAIL_ID', this.locationId);
      this.$store.dispatch('shipment_md/locations/LOAD_DETAIL_DATA');
    }

    this.$store.dispatch('companies/LOAD_INFO').then(() => {
      this.$store.commit('companies/SET_QUERY_COUNT', this.count_all);
      this.$store.dispatch('companies/LOAD_DATA').then(() => {
        if (!isUndefined(companyId)) {
          this.selectedCustomer = find(this.customers, { id: companyId });
        }
      });
    });
    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
  },
  mounted() {
    this.$nextTick(() => {
      this.mapObject = this.$refs.map.mapObject;
      const editableLayers = new L.FeatureGroup();
      this.mapObject.addLayer(editableLayers);

      if (this.isEdit) {
        setTimeout(() => {
          let bounds = null;
          if (this.form.geometry.type === 'Polygon') {
            bounds = L.polygon(this.form.geometry.coordinates).getBounds();
          } else {
            bounds = L.latLng(this.form.geometry.coordinates).toBounds(get(this.form, 'metadata.radius', 75));
          }
          this.mapObject.fitBounds(bounds);
        }, 1e3);
      }

      const options = {
        position: 'bottomleft',
        draw: {
          polyline: false,
          polygon: {
            icon: new L.DivIcon({
              iconSize: new L.Point(14, 14),
              className: 'leaflet-div-icon leaflet-editing-icon',
            }),
          },
          circle: true,
          rectangle: false,
          marker: false,
          circlemarker: false,
        },
        edit: {
          featureGroup: editableLayers,
          remove: true,
        },
      };

      this.drawControl = new L.Control.Draw(options);
      this.mapObject.addControl(this.drawControl);

      this.mapObject.on(L.Draw.Event.CREATED, (e) => {
        const { layer, layerType } = e;

        if (layerType === 'polygon') {
          const latLngs = find(layer.getLatLngs());
          this.form.geometry.type = 'Polygon';
          this.form.geometry.coordinates = map(latLngs, latlng => values(latlng));
        } else if (layerType === 'circle') {
          const { lat, lng } = layer.getLatLng();
          const radius = layer.getRadius();
          this.form.geometry.type = 'Point';
          this.form.latitude = lat;
          this.form.longitude = lng;
          this.form.geometry.coordinates = [lat, lng];
          this.form.metadata.radius = radius;
        }

        this.drawControl.setDrawingOptions({
          polygon: false,
          circle: false,
        });

        this.mapObject.removeControl(this.drawControl);
        this.mapObject.addControl(this.drawControl);

        return editableLayers.addLayer(layer);
      });

      this.mapObject.on(L.Draw.Event.DELETED, () => {
        this.form.geometry.type = '';
        this.form.geometry.coordinates = '';
        this.form.longitude = '';
        this.form.latitude = '';

        this.drawControl.setDrawingOptions({
          polygon: true,
          circle: true,
        });

        this.mapObject.removeControl(this.drawControl);
        this.mapObject.addControl(this.drawControl);
      });

      this.mapObject.on(L.Draw.Event.EDITED, (e) => {
        const { layers } = e;
        const getLayers = find(layers.getLayers());

        if (!isUndefined(getLayers.getLatLngs)) {
          const latLngs = find(getLayers.getLatLngs());
          const coordinates = map(latLngs, ({ lat, lng }) => ([lat, lng]));
          this.form.geometry.type = 'Polygon';
          this.form.geometry.coordinates = new Array(coordinates);
        } else if (!isUndefined(getLayers.getLatLng)) {
          const { lat, lng } = getLayers.getLatLng();
          const radius = getLayers.getRadius();
          this.form.geometry.type = 'Point';
          this.form.latitude = lat;
          this.form.longitude = lng;
          this.form.geometry.coordinates = [lat, lng];
          this.form.metadata.radius = radius;
        }
      });
    });
  },
  computed: {
    customers() {
      const companies = this.$store.getters['companies/companies'];
      const customers = this.$store.getters['companies/customers'];
      const tenants = this.$store.getters['companies/tenants'];
      const manufacturers = this.$store.getters['companies/manufacturers'];

      if (!this.isSystemAdmin) return uniqBy(concat(customers, tenants, manufacturers), 'id');
      return companies;
    },
    detailedInfo() {
      const detailData = this.$store.getters['shipment_md/locations/get_detail_data'];
      const detailInfo = this.isEdit ? detailData : {};
      return detailInfo;
    },
    displayName() {
      return this.detailedInfo.name;
    },
    count_all() {
      return this.$store.getters['companies/count_all'];
    },
    header() {
      const header = this.isEdit
        ? `Edit Location : ${this.displayName}`
        : 'Create New Location';
      return header;
    },
    locationId() {
      return this.$route.params.locationId;
    },
    isEdit() {
      return !isEmpty(this.locationId) && !isUndefined(this.locationId);
    },
    userData() {
      return this.$store.getters.userData;
    },
    isSystemAdmin() {
      const { type } = this.userData;
      return type === 'SYSTEM_ADMIN';
    },
    isAddFromSelectedCustomer() {
      return !isEmpty(this.$route.params.locationId) || !isEmpty(this.$route.params.companyId);
    },
    isFormReset() {
      const { company_id } = this.form;
      return isUndefined(company_id);
    },
    query() {
      return this.address.query;
    },
  },
  watch: {
    detailedInfo(data) {
      if (this.isSubmit) {
        return;
      }

      this.form = { ...data };
      this.selectedCustomer = data.company;

      const { map: { mapObject } } = this.$refs;
      const { geometry } = data;
      const { type } = geometry;
      let { coordinates } = geometry;
      const layer = findLast(mapObject._layers);

      const firstCoordinate = get(coordinates, '0.0') || [0, 0];
      const inValidCoordinates = firstCoordinate[0] > 0;

      let bounds = null;

      if (type === 'Polygon') {
        coordinates = inValidCoordinates ? this.reverseCoordinates(coordinates) : coordinates;
        this.form.geometry.coordinates = coordinates;

        const polygon = L.polygon(coordinates);
        const center = polygon.getBounds().getCenter();
        layer.addLayer(polygon);
        this.map.center = values(center);
        bounds = L.polygon(coordinates).getBounds();
      } else if (type === 'Point') {
        let coords = values(coordinates);
        let { metadata: { radius } } = data;
        if (isUndefined(radius) || isNull(radius)) radius = 75;
        if (coords[0] > 0) {
          coords = [coords[1], coords[0]];
        }
        const circle = L.circle(coords, {
          radius,
        });
        layer.addLayer(circle);
        this.form.geometry.coordinates = coords;
        this.map.center = values(coords);
        bounds = L.latLng(coords).toBounds(get(data, 'metadata.radius', 75));
      }

      this.drawControl.setDrawingOptions({
        polygon: false,
        circle: false,
      });

      mapObject.removeControl(this.drawControl);
      mapObject.addControl(this.drawControl);

      setTimeout(() => {
        mapObject.fitBounds(bounds);
      }, 1e3);
    },
    query(value) {
      if (value === '' || this.address.finish) {
        this.address.query = '';
        this.address.open = false;
        this.address.finish = false;
        return;
      }
      this.searchAddress(this, value);
    },
    selectedCustomer(customer) {
      const { id } = customer || {};
      this.form.company_id = id;
    },
    marker(value) {
      this.markerMoved(this, value);
    },
  },
  methods: {
    searchAddress: debounce((context, value) => {
      context.$store.dispatch('shipment_md/locations/SEARCH_ADDRESS', value).then((address) => {
        if (!isEmpty(address)) {
          context.address.openSuggestion = true;
          context.address.suggestion = find(address);
        }
      });
    }, 300, {
      leading: false,
    }),
    selectLocation() {
      const { geometry } = this.address.suggestion;
      const { location: { lat, lng } } = geometry;
      this.map.zoom = 18;
      this.map.center = [lat, lng];
      this.address.query = '';
      this.address.openSuggestion = false;
      this.address.finish = true;
      const bounds = L.latLng(this.map.center).toBounds(75);
      this.mapObject.fitBounds(bounds);
    },
    onSubmit() {
      this.validate().then((valid) => {
        if (valid) {
          const companyId = get(this.$route, 'params.companyId', undefined);
          let { locationId } = this.$route.params;
          const action = this.isEdit ? 'UPDATE_DATA' : 'CREATE_DATA';
          const { geometry: { type } } = this.form;
          this.isSubmit = true;

          if (type === 'Polygon') {
            delete this.form.longitude;
            delete this.form.latitude;
            delete this.form.metadata.radius;
            // this.form.geometry.coordinates = [this.form.geometry.coordinates];
          }

          this.$store.dispatch(`shipment_md/locations/${action}`, this.form).then((location) => {
            locationId = this.isEdit ? locationId : location.id;
            if (!isUndefined(companyId)) {
              this.$router.push(`/shipment_md/customers/${companyId}/locations`);
            } else {
              this.$router.push(`/shipment_md/locations/${locationId}`);
            }
          });
        }
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    onCancel() {
      const { locationId, companyId } = this.$route.params;
      if (!isUndefined(companyId)) {
        this.$router.push(`/shipment_md/customers/${companyId}/locations`);
      } else if (this.isEdit) {
        this.$router.push(`/shipment_md/locations/${locationId}`);
      } else {
        this.$router.push('/shipment_md/locations');
      }
    },
    reverseCoordinates(coordinates) {
      const reversed = coordinates.map((dt) => {
        const coords = dt.map(([point1, point2]) => ([point2, point1]));
        return coords;
      });
      return reversed;
    },
  },
};
</script>
<style lang="sass">
@import "~leaflet/dist/leaflet.css";
@import "~leaflet-draw/dist/leaflet.draw.css";
@import "~vue-multiselect/dist/vue-multiselect.min"
.multiselect-danger .multiselect__tags
  border: 1px solid #f86c6b
.location-form
  .multiselect__content-wrapper
    max-height: 120px !important;
.leaflet-control-container
  height: 500px;
.input-address
  position: absolute;
  z-index: 1000;
.leaflet-draw-toolbar a
  background-image: url('~static/img/leaflet/spritesheet.png');
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/locations/CreateEdit.vue